import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import type { AdminModuleDefinition } from '@/types/adminModule';

const adminModules: AdminModuleDefinition[] = [
  {
    id: 'product-management',
    nameKey: 'admin.adminModules.productManagement',
    icon: Inventory2OutlinedIcon,
    sortOrder: 1,
    contentType: 'internal',
    permission: 'PRODUCTS_READ',
  },
  {
    id: 'product-menu-management',
    nameKey: 'admin.adminModules.productMenuManagement',
    icon: MenuBookOutlinedIcon,
    sortOrder: 2,
    contentType: 'internal',
    permission: 'PRODUCT_MENU_CONFIGURATION_READ',
  },
  {
    id: 'notifications',
    nameKey: 'admin.adminModules.notifications',
    icon: NotificationsOutlinedIcon,
    sortOrder: 3,
    contentType: 'internal',
    permission: 'NOTIFICATIONS_READ',
  },
];

export const getAdminModules = (): AdminModuleDefinition[] =>
  [...adminModules].sort((left, right) => left.sortOrder - right.sortOrder);

export const getAdminModuleById = (
  moduleId: string,
): AdminModuleDefinition | undefined =>
  adminModules.find((module) => module.id === moduleId);

export const defaultAdminModuleId = 'product-management';
